import { render, staticRenderFns } from "./TreatyAccountingClosing.vue?vue&type=template&id=0a8a8b9c&"
import script from "./TreatyAccountingClosing.vue?vue&type=script&lang=js&"
export * from "./TreatyAccountingClosing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports